import CloudinaryImage from "@/components/CloudinaryImage.vue";
export default {
  name: "planCoverage",
  components: {
    CloudImage: CloudinaryImage
  }
};